(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("element-utils"), require("animate-keyframes"), require("html-tags"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "element-utils", "animate-keyframes", "html-tags"], factory);
	else if(typeof exports === 'object')
		exports["animateComponents"] = factory(require("react"), require("prop-types"), require("element-utils"), require("animate-keyframes"), require("html-tags"));
	else
		root["animateComponents"] = factory(root["react"], root["prop-types"], root["element-utils"], root["animate-keyframes"], root["html-tags"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_5__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition